import React from 'react';
import PropTypes from "prop-types";

import {OptionalContent} from "../../../../components/OptionalContent";
import GuestItem from "./GuestItem";

import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

const GuestsList = ({booking, onGuestEdit, onGuestDelete} )=> {
    const guests = booking.guests;

    return <Box sx={{mt: 2, mb: 3}}>
        <OptionalContent hasContent={guests.length > 0}
                         noContentMessage="Nessun ospite associato a questa prenotazione."
                         showIcon>
            <Divider/>
            {
                guests.map(g => (
                    <React.Fragment key={g.id}>
                        <Stack direction="row" alignItems="center">
                            <GuestItem guest={g}
                                       defaultArrivalDate={booking.getArrival()}
                                       defaultDepartureDate={booking.getDeparture()}
                                       showTouristTax={true}
                                       showStatus={true}/>
                            <IconButton size="small" onClick={() => onGuestDelete(g)} disabled={!g.canEdit() || !booking.isEditable()}>
                                <DeleteIcon fontSize="small"/>
                            </IconButton>
                            <IconButton size="small" onClick={() => onGuestEdit(g)} disabled={!g.canEdit() || !booking.isEditable()}>
                                <EditIcon fontSize="small"/>
                            </IconButton>
                        </Stack>
                        <Divider/>
                    </React.Fragment>
                ))
            }

        </OptionalContent>
    </Box>
};

GuestsList.propTypes = {
    booking: PropTypes.object.isRequired,
    onGuestEdit: PropTypes.func.isRequired,
    onGuestDelete: PropTypes.func.isRequired,
}

export default GuestsList;